export default __webpack_public_path__ + "static/mens-689d4c28428078b69ff81ac7fdc84099.jpg";